// extracted by mini-css-extract-plugin
export var sideBlock = "side-blocks-module--sideBlock--5ca19";
export var sideBlocks = "side-blocks-module--sideBlocks--ac68a";